import React, { useEffect, useState } from "react";
import i18n from "../../../../helper/i18n";
import Layout from "../../Layout/Layout";

const AssignmentAiInsights = (props) => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 767);

  const getCurrentLanguage = () => {
    const languageMappings = {
      en: "en",
      "en-GB": "en",
      "en-US": "en",
      es: "es",
      pt: "pt",
      de: "de",
      fr: "fr",
      hi: "hi",
      // Add other languages as needed
    };
    return languageMappings[i18n.language];
  };

  const currentLanguage = getCurrentLanguage();

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 767);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const url =
    process.env.REACT_APP_EP_AI_INSIGHTS || "https://ai-insights.acv.app";

  return (
    <Layout isReportAvailable={true} isMobileView={isMobileView}>
      <iframe
        className="assignment-ai-insights"
        src={`${url}${props.user.slug}&email=${props.user.mail}&language=${currentLanguage}&mode=1`}
        style={{
          height: "calc(100vh - 150px)",
          width: "100%",
          border: 0,
        }}
      ></iframe>
    </Layout>
  );
};

export default AssignmentAiInsights;
